import React, { useEffect, useState } from "react";
import {
  Portlet, PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../../components/Portlet";
import CityForm from "../components/cityForm";
import { connect } from "react-redux";
import {
  DeleteItem,
  GetItem,
  UpdateItem
} from "../../../../redux/actions/base";
import {CityListRoute, TouristServicesListRoute} from "../../../routesConstants";
import {Link, useParams} from "react-router-dom";
import BlockUi from "@availity/block-ui";
import { Dropdown, Row, Col } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import Process from "../../../../components/process";
import {Helmet} from "react-helmet";
import GoogleMapReact from "google-map-react";
import IconForMap from "../../../trips/components/IconForMap";
import axios from "../../../../helpers/axios";
import {useNavigate} from "react-router";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";


export const renderLocationsLinks = (mainItem) =>{
  return mainItem.items.map((item, index)=>{
    return <Link key={index} target={'_blank'} to={mainItem.baseLink+item.id}>{item.name}</Link>
  })
}

const CityEditPage = () => {
  const [city, setCity] = useState(null);
  const [loader, setLoader] = useState(true)
  const navigation = useNavigate()
  const { id } = useParams();
  useEffect(() => {
    if (city === null) {
      axios.get("/api/locations/cities/"+id)
        .then(({data})=>{
          console.log('data', data)
          setCity(data.data)
          setLoader(false)
        })
    }
  }, [city, id]);
  const callback = (values, cb) => {
    setLoader(true)
    axios.patch("/api/locations/cities/" + id, values)
      .then(()=>{
        navigation(CityListRoute)
      })
      .finally(()=>setLoader(false))
  };

  const deleteAction = () => {
    if(window.confirm('Вы уверены, что хотите удалить?')){
      setLoader(true);
      axios.delete("/api/locations/cities/" + id)
        .then(()=>{
          navigation(CityListRoute)
        })
        .finally(()=>setLoader(false))
    }
  };
  return (
    <>
      <Helmet>
        <title>{city?.name || "Город"}</title>
      </Helmet>
      <BlockUi blocking={!city || loader}>
        {city && <>
          <Breadcrumbs aria-label="Breadcrumb" style={{paddingBottom: 15}}>
            {renderLocationsLinks(city.navigation.previous)}
            <Typography color="textPrimary">{city?.name?.length >0 ? city.name :  city.nameEn}</Typography>
            {renderLocationsLinks(city.navigation.next)}
          </Breadcrumbs>
          <CityForm onSubmit={callback}
                    data={city}
                    edit deleteAction={deleteAction}/>
        </>}
      </BlockUi>
    </>
  );
};

export default CityEditPage;
